// 配置高德地图密钥转发接口地址
export const setAMapSecurityConfig = () => {
  const host =
    process.env.REACT_APP_DEP === 'prod'
      ? 'https://ow.survey.work/'
      : 'https://ow-dev.survey.work/'

  window._AMapSecurityConfig = {
    serviceHost: `${host}_AMapService`,
  }
}
